export const MAX_LOGIN_ATTEMPT = 3
export const ATTEMPT_LOGIN_RESET_INTERVAL = 2 * 60 * 60 * 1000 // 2 hours
export const FIRST_ACCESS_REQUERED_LOCAL_STORAGE_KEY = 'd8ed6971-a6c0-48f7-97e6-8e8b5a90647f'
export const FORGOT_PASSWORD_REQUIRED_LOCAL_STORAGE_KEY = '21014973-de83-441f-94af-f47bb182564c'
export const ATTEPTS_USERS_FROMDB = 'b6415c0d-ac6f-4ec2-a6e3-6888d37db6f8'
export const LOGIN_ATTEMPTS_TITLE_MESSAGE = 'Não foi possível realizar Login.'
export const LOGIN_ATTEMPTS_DEFAULT_DESCRIPTION_MESSAGE = 'Por favor, verifique os dados digitados e tente novamente!'
export const LOGIN_ATTEMPTS_DESCRIPTION_MESSAGE_ALERT_CHANGE_PASSWORD_PART_ONE = 'Após a Terceira Tentativa, '
export const LOGIN_ATTEMPTS_DESCRIPTION_MESSAGE_ALERT_CHANGE_PASSWORD_PART_TWO = 'será necessário trocar a senha.'